import { getGoDaddyDomainDetails } from '../services/getGoDaddyDomainDetails';
import { getPremiumLegacyTenant } from '../services/getPremiumLegacyTenant';
import PurchaseType from '../contracts/purchaseType';
import setGoDaddyDomainDetails from '../mutators/setGoDaddyDomainDetails';
import setPremiumLegacyTenant from '../mutators/setPremiumLegacyTenant';
import getPremiumUserState from './getPremiumUserState';
import store from '../store/store';
import { getWhoIsDomainDetails } from '../services/getWhoisDomainDetails';
import setTransferDomain from '../mutators/setTransferDomain';
import setloadStateOfGodaddyDomainDetails from '../mutators/setloadStateOfGodaddyDomainDetails';
import updateMXRecords from '../orchestrators/updateMXRecords';
import { LoadState } from '../store/schema/loadState';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

export default function getDomainDetails() {
    if (
        store.legacyPremiumUserDomainState.loadState == LoadState.Uninitialized &&
        store.legacyPremiumUserDomainState.authCode == '' &&
        isConsumer()
    ) {
        const promiseGetDomainDetails = new Promise(resolve => {
            setTimeout(async () => {
                setloadStateOfGodaddyDomainDetails(LoadState.Loading);
                getPremiumUserState().then(() => {
                    if (
                        store.legacyPremiumTenant.TenantName == '' &&
                        store.userInfo.isProsumerConsumerMailbox
                    ) {
                        getPremiumLegacyTenant().then(response => {
                            setPremiumLegacyTenant(response);
                            updateMXRecords('updateMXRecords');
                            if (store.legacyPremiumTenant.TenantName != null) {
                                getWhoIsDomainDetails().then(response => {
                                    if (
                                        response.raw &&
                                        response.raw.search('www.wildwestdomains.com') == -1
                                    ) {
                                        setTransferDomain(true);
                                    } else {
                                        setTransferDomain(false);
                                    }
                                });
                            }
                        });
                    }
                    const isAutoPurchasedDomain =
                        store.legacyPremiumTenant.DomainPurchaseType == PurchaseType.AutoPurchased;
                    if (isAutoPurchasedDomain) {
                        getGoDaddyDomainDetails(store.legacyPremiumTenant.TenantName).then(
                            response => {
                                setGoDaddyDomainDetails(response);
                            }
                        );
                    }
                    resolve();
                });
            }, 0);
        });

        promiseGetDomainDetails.then(() => {
            // Add a check that if the store.legacyPremiumIsInitialized has value, set the loadState to initialized
            if (
                store.legacyPremiumUserDomainState.authCode == '' ||
                store.legacyPremiumUserDomainState.authCode == undefined
            ) {
                setloadStateOfGodaddyDomainDetails(LoadState.Uninitialized);
            } else {
                setloadStateOfGodaddyDomainDetails(LoadState.Initialized);
            }
        });
    }
}
